import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[ezPanelType]',
  standalone: false,
})
export class PanelTypeDirective {
  readonly viewContainerRef = inject(ViewContainerRef);
}
